<template>
  <div>
    <!-- redirect modal -->
    <div v-if="showRedirectModal">
      <div class="modal-backdrop fade show"></div>
      <div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Perhatian</h5>
              <button type="button" class="close" @click="showRedirectModal=false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              Demi pengalaman pencarian yang lebih baik, pengecekan HET kini dapat diakses di laman baru.
              <br/><br/>
              Klik tombol "Kunjungi" untuk beralih.
            </div>
            <div class="modal-footer">
              <a href="https://buku.kemendikdasmen.go.id/hasil-penilaian" target="_blank" class="btn btn-primary">Kunjungi</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <banner
      title="Daftar Hasil Penilaian Buku "
      :breadcrumbs="breadcrumbs"
      :icon="require('@/assets/home/decoration/book.svg')"
    />

    <section id="content" class="mt-4">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <div class="sidebar p-3">
              <div class="mb-3 mt-3">Filter berdasarkan field berikut :</div>
              <form @submit.prevent="getAssessment(true)">
                <div class="form-group">
                  <div for="" class="h6 font-weight-bold">Tipe</div>
                  <div
                    class="custom-control custom-radio"
                    v-for="option in typeOptions"
                    :key="option.value"
                  >
                    <input
                      type="radio"
                      :value="option.value"
                      :id="option.label"
                      v-model="filter.type"
                      class="custom-control-input"
                    />
                    <label :for="option.label" class="custom-control-label">{{
                      option.label
                    }}</label>
                  </div>
                </div>
                <div class="form-group">
                  <label for="" class="h6 font-weight-bold">Judul</label>
                  <input
                    v-model="filter.title"
                    type="text"
                    class="form-control search_table"
                    placeholder="Ketikan Judul Buku"
                  />
                </div>
                <div class="form-group">
                  <label for="" class="h6 font-weight-bold">Nama Penulis</label>
                  <input
                    v-model="filter.author"
                    type="text"
                    class="form-control search_table"
                    placeholder="Ketikan Nama Penulis"
                  />
                </div>
                <!-- <div class="form-group">
                  <label for="" class="h6 font-weight-bold"
                    >Nama Penerbit</label
                  >
                  <input
                    v-model="filter.publisher"
                    type="text"
                    class="form-control search_table"
                    placeholder="Ketikan Nama Penerbit"
                  />
                </div> -->

                <!-- <div class="form-group">
                  <label for="" class="h6 font-weight-bold">Peruntukan</label>
                  <div
                    class="custom-control custom-checkbox"
                    v-for="option in allotmentOptions"
                    :key="option.value"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="option.value"
                      :checked="option.value === filter.edu_stage"
                      @change="changeAllotment($event, option.value)"
                      :id="option.label"
                    />
                    <label class="custom-control-label " :for="option.label">
                      {{ option.label }}
                    </label>
                  </div>
                </div> -->
                <div class="form-group">
                  <label for="" class="h6 font-weight-bold">SK Kelayakan</label>
                  <input
                    v-model="filter.no_sk"
                    type="text"
                    class="form-control search_table"
                    placeholder="SK Kelayakan"
                  />
                </div>
                <div class="d-flex justify-content-between">
                  <button
                    ref="loader"
                    @click="resetAssessment"
                    class="btn btn-outline-primary w-100 mr-1"
                    type="button"
                  >
                    Reset
                  </button>
                  <button
                    ref="loader"
                    @click="getAssessment(true)"
                    class="btn btn-primary w-100 ml-1"
                    type="submit"
                  >
                    Terapkan
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-9">
            <div
              v-if="$store.state.loadPage"
              style="height: 400px"
              class="d-flex justify-content-center align-items-center"
            >
              <img src="@/assets/loading-2.gif" class="img-fluid" alt="" />
            </div>

            <div v-else class="table-responsive">
              <table class="table result-table border" data-pagination="true">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Judul Buku</th>
                    <th scope="col">Penulis</th>
                    <th scope="col">Penerbit</th>
                    <th scope="col">Kategori</th>
                    <th scope="col">Peruntukan</th>
                    <th scope="col">SK Kelayakan</th>
                    <th scope="col">Deskripsi</th>
                    <template v-if="filter.type === 'btp'">
                      <th scope="col">Zona 1</th>
                      <th scope="col">Zona 2</th>
                      <th scope="col">Zona 3</th>
                      <th scope="col">Zona 4</th>
                      <th scope="col">Zona 5</th>
                      <th scope="col">Zona 6</th>
                    </template>
                    <template v-else>
                      <th scope="col">Harga</th>
                    </template>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(assessment, index) in assessments" :key="index">
                    <!-- <td>
                      <img
                        src="https://image.web.id/images/Dummy.png"
                        class="rounded"
                        style="width: 48px"
                      />
                    </td> -->
                    <td>{{ assessment.title ?? "-" }}</td>
                    <td>{{ assessment.author ?? "-" }}</td>
                    <td>{{ assessment.publisher.name ?? "-" }}</td>
                    <td>{{ assessment?.category?.name ?? "-" }}</td>
                    <td>{{ assessment.school_level.name ?? "-" }}</td>
                    <td>{{ assessment.sk_number ?? "-" }}</td>
                    <td>{{ assessment.descriptions ?? "-" }}</td>
                    <template v-if="filter.type === 'btp'">
                      <td>Rp {{ assessment.book_prices[0]?.price ?? '-' }}</td>
                      <td>Rp {{ assessment.book_prices[1]?.price ?? '-' }}</td>
                      <td>Rp {{ assessment.book_prices[2]?.price ?? '-' }}</td>
                      <td>Rp {{ assessment.book_prices[3]?.price ?? '-' }}</td>
                      <td>Rp {{ assessment.book_prices[4]?.price ?? '-' }}</td>
                      <td>Rp {{ assessment.book_prices[5]?.price ?? '-' }}</td>
                    </template>
                    <template v-else>
                      <td>Rp {{ assessment.price ?? '-' }}</td>
                    </template>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="99">
                      <div
                        class="d-flex justify-content-between align-items-center"
                        v-if="assessments.length"
                      >
                        <span>
                          Menampilkan {{ metadata.perPage }} dari
                          {{ formatNumber(metadata.total_rows) }} hasil
                        </span>

                        <pagination
                          class="m-0"
                          :current-page="pageNumber"
                          :total-data="metadata.total_rows"
                          :total-page="totalPage"
                          :key="totalPage"
                          :max-page="3"
                          @change="onChangePage"
                        />
                      </div>
                      <div v-else class="text-center">Data tidak ditemukan</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- row -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
}
</style>

<script>
import axios from "axios";
import { BASE_URL } from "../../../store";

import Banner from "../../../components/homepage/Banner.vue";
import Pagination from "@/components/common/Pagination";

import $ from "jquery";

export default {
  components: { Banner, Pagination },
  name: "Penilaian",
  data() {
    return {
      breadcrumbs: [
        {
          label: "Beranda",
          url: "/",
        },
        {
          label: "Hasil Penilaian",
          url: "",
        },
      ],
      typeOptions: [
        {
          label: "Buku Teks",
          value: "btp",
        },
        {
          label: "Buku Non Teks",
          value: "bntp",
        },
      ],
      allotmentOptions: [
        {
          label: "PAUD",
          value: "paud",
        },
        {
          label: "SD/MI",
          value: "sd",
        },
        {
          label: "SMP/MTS",
          value: "smp",
        },
        {
          label: "SMA/MA/SMK/MAK",
          value: "smk",
        },
        {
          label: "SLB (SDLB/SMPLB/SMALB)",
          value: "slb",
        },
      ],
      pageNumber: 1,
      filter: {
        type: "btp",
        title: "",
        author: "",
        publisher: "",
        edu_stage: "",
        no_sk: "",
      },
      assessments: [],
      metadata: {
        perPage: 15,
        rowno: 0,
        total_rows: 0,
        total_pages: 0,
      },
      showRedirectModal: false,
    };
  },
  computed: {
    checkTotal() {
      if (this.$store.state.perPage == this.$store.state.totalRows) {
        return false;
      }
      return true;
    },
    totalPage() {
      return this.metadata.total_pages;
    },
  },
  methods: {
    getAssessment(resetPage) {
      if (resetPage) {
        this.pageNumber = 1;
      }
      // check query params and get title and type
      if (this.$route.query.title) {
        this.filter.title = this.$route.query.title;
      }
      if (this.$route.query.type) {
        this.filter.type = this.$route.query.type;
      }

      axios
        .get(
          `${BASE_URL}${this.filter.type}/book?code=GuruSejahtera2025&page=${this.pageNumber}&per_page=${this.metadata.perPage}`,
          {
            params: {
              // "filter[assessment][type]": this.filter.type,
              title: this.filter.title,
              author: this.filter.author,
              publisher: this.filter.publisher,
              sk_number: this.filter.no_sk,
              // "filter[assessment][edu_stage]": this.filter.edu_stage,
            },
          }
        )
        .then((res) => {
          const { data } = res.data;
          this.assessments = data;
          const metadata = {
            perPage: +Number(res.data.pagination.per_page),
            rowno:
              +res.data.pagination.page * Number(res.data.pagination.per_page),
            total_rows: +res.data.pagination.total_items,
            total_pages: +res.data.pagination.total_pages,
          };
          this.metadata = metadata;
        })
        .catch((err) => {
          console.log(err)
          this.assessments = [];
        });
    },
    resetAssessment() {
      this.filter = {
        type: "btp",
        title: "",
        author: "",
        publisher: "",
        edu_stage: "",
        no_sk: "",
      };
      this.pageNumber = 1;
      this.getAssessment();
    },
    onChangePage(e) {
      this.pageNumber = e;
      this.getAssessment();
    },
    changeAllotment(e, val) {
      if (e.target.checked) {
        this.filter.edu_stage = val;
      } else {
        this.filter.edu_stage = "";
      }
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
  },
  watch: {
    "filter.type": {
      handler(newType, oldType) {
        console.log(
          `Filter Tipe berubah dari '${oldType}' menjadi '${newType}'.`
        );
        this.getAssessment();
      },
      immediate: true, // Panggil handler saat komponen dimuat pertama kali
    },
  },
  created() {
    // show informational alert about HET redirect
    this.showRedirectModal = true;
    this.getAssessment();
  },
  mounted() {
    this.$nextTick(() => {
      $(function () {
        $('[data-toggle="popover"]').popover({
          container: "body",
        });
      });
    });
  },
};
</script>
